.dot{color:#e31c3d}.bolt{color:#765dd8}
/*# sourceMappingURL=edit-secondary-toolbar-2d.component.css.map */
